module.exports = __webpack_public_path__ + "bf8c1feb.png";